// PickleTimes Custom JS

function splitProductCardTitles() {
  if (window.location.pathname.includes('/products/')) return;
  var cardTitles = document.querySelectorAll('.product-card__title');
  cardTitles.forEach(function(el) {
    if (el.querySelector('br')) return;
    var text = el.innerText || el.textContent;
    var parts = text.split(' — ');
    if (parts.length > 1) {
      el.innerHTML = parts[0].trim() + '<br>' + parts[1].trim();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', splitProductCardTitles);
} else {
  splitProductCardTitles();
}

setTimeout(splitProductCardTitles, 300);
setTimeout(splitProductCardTitles, 800);
setTimeout(splitProductCardTitles, 1500);
